import axios from "axios";
import config from "../configs/config";
// import MyPlugin from "@/plugins/plugin";
import { useUserStore } from "@/stores/UserStore";
import { useGeneralStore } from "@/stores/GeneralStore";
import languages from "@/configs/language";

function safeNetworkError(err, userStore, generalStore) {
  if (!err.response) {
    return {
      status: 400,
      data: { msg: "Network error. Please check your connection." },
    };
  }
  const res = err.response;
  if (err.code === "ECONNABORTED") {
    return {
      status: 400,
      data: { msg: "Request timeout. Please check your network and try again later." },
    };
  }
  if (res.status === 401) {
    generalStore.showGeneralDialog(
      `${languages[generalStore.choosedLanguage]["session_expired"]}`,
      true
    );
    userStore.userLogout();
    window.location.reload(true);
  }
  return res;
}

const mainAPI = {
  // NONAKTIF — panggilan FAST sekarang lewat tms_reapi (reApiRequest → fordex/loading-list/*, fordex/*).
  // Sengaja di-comment (bukan dihapus) untuk referensi/rollback. Kredensial FAST TIDAK boleh ditaruh di frontend.
  // requestFordex(header, body, timeout) {
  //   let userStore = useUserStore();
  //   let generalStore = useGeneralStore();
  //
  //   header = {
  //     ...header,
  //     Authorization: `Bearer ${userStore.access_token}`,
  //   };
  //
  //   return axios
  //     .post(
  //       `${config.baseApiUrl}/fordex`,
  //       JSON.stringify(body),
  //       {
  //         timeout: timeout,
  //         headers: header,
  //       }
  //     )
  //     .then(async (res) => {
  //       //check res status
  //       if (res.status == 202) {
  //         if (!generalStore.isRefreshingToken) {
  //           generalStore.isRefreshingToken = true;
  //           await userStore.getAccessToken();
  //           generalStore.isRefreshingToken = false;
  //         }
  //
  //         res.status = 200;
  //       }
  //       return res;
  //     })
  //     .catch((err) => safeNetworkError(err, userStore, generalStore));
  // },

  requestHandlerSwitch(header, body, timeout) {
    let userStore = useUserStore();
    let generalStore = useGeneralStore();

    header = {
      ...header,
      Authorization: `Bearer ${userStore.access_token}`,
    };

    return axios
      .post(
        `${config.baseApiUrl}/requesthandlerswitch`,
        JSON.stringify(body),
        {
          timeout: timeout,
          headers: header,
        }
      )
      .then(async (res) => {
        //check res status
        if (res.status == 202) {
          if (!generalStore.isRefreshingToken) {
            generalStore.isRefreshingToken = true;
            await userStore.getAccessToken();
            generalStore.isRefreshingToken = false;
          }

          res.status = 200;
        }
        return res;
      })
      .catch((err) => safeNetworkError(err, userStore, generalStore));
  },

  requestHandler(header, body, timeout) {
    let userStore = useUserStore();
    let generalStore = useGeneralStore();

    header = {
      ...header,
      Authorization: `Bearer ${userStore.access_token}`,
    };

    return axios
      .post(
        `${config.baseApiUrl}/requesthandler`,
        JSON.stringify(body),
        {
          timeout: timeout,
          headers: header,
        }
      )
      .then(async (res) => {
        if (res.status == 202) {
          if (!generalStore.isRefreshingToken) {
            generalStore.isRefreshingToken = true;
            //get new access token
            await userStore.getAccessToken();
            generalStore.isRefreshingToken = false;
          }

          res.status = 200; //always do 200
        }
        return res;
      })
      .catch((err) => safeNetworkError(err, userStore, generalStore));
  },

  requestHandlerRevamp(header, body, timeout) {
    let userStore = useUserStore();
    let generalStore = useGeneralStore();

    header = {
      ...header,
      Authorization: `Bearer ${userStore.access_token}`,
    };

    return axios
      .post(
        `${config.reApiUrl}/requesthandler`,
        JSON.stringify(body),
        {
          timeout: timeout,
          headers: header,
        }
      )
      .then(async (res) => {
        if (res.status == 202) {
          if (!generalStore.isRefreshingToken) {
            generalStore.isRefreshingToken = true;
            await userStore.getAccessToken();
            generalStore.isRefreshingToken = false;
          }

          res.status = 200;
        }
        return res;
      })
      .catch((err) => safeNetworkError(err, userStore, generalStore));
  },

  reApiRequest(header, body, request) {
    let userStore = useUserStore();
    let generalStore = useGeneralStore();
    
    header = {
      ...header,
      Authorization: `Bearer ${userStore.access_token}`,
    };

    return axios
      .post(
        `${config.reApiUrl}/${request}`,
        JSON.stringify(body),
        {
          headers: header,
        }
      )
      .then(async (res) => {
        if (res.status == 202) {
          if (!generalStore.isRefreshingToken) {
            generalStore.isRefreshingToken = true;
            await userStore.getAccessToken();
            generalStore.isRefreshingToken = false;
          }

          res.status = 200;
        }
        return res;
      })
      .catch((err) => safeNetworkError(err, userStore, generalStore));
  },

  uploadImage(header, body) {
    return axios
      .post(`${config.uploadImageUrl}`, JSON.stringify(body), {
        headers: header,
      })
      .then((res) => {
        return res;
      })
      .catch((err) => err.response || { status: 400, data: { msg: "Network error." } });
  },
  downloadImage(header, data) {
    let queryParams = new URLSearchParams({
      file: data.docpath + "/" + data.document_name,
    }).toString(); // Mengubah objek data menjadi string query

    let url = `${config.downloadImageUrl}?${queryParams}`; // Menambahkan query string ke URL

    return axios
      .get(url, {
        headers: header,
      })
      .then((res) => {
        return res.data; // Mengembalikan data dari respon
      })
      .catch((err) => {
        return err.response.data; // Mengembalikan data error dari respon
      });
  },
  uploadDocument(header, body) {
    let userStore = useUserStore();

    const fullHeader = {
      ...header,
      Authorization: `Bearer ${userStore.access_token}`,
    };

    const formData = new FormData();
    for (const key in body) {
      formData.append(key, body[key]);
    }

    return axios
      .post(`${config.baseApiUrl}/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          ...fullHeader,
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.response;
      });
  },
  spildexHandler(token, body, endpoint, timeout) {
    let header = {
      Clientname: "spil",
      Authorization: "Bearer " + token,
    };

    return axios
      .post(
        `${config.spildexApiUrl}/` + endpoint + ``,
        JSON.stringify(body.params),
        {
          timeout: timeout,
          headers: header,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        if (!err.response || err.code === "ECONNABORTED") {
          return {
            status: 400,
            data: { msg: "Request timeout. Please check your network and try again later." },
          };
        }
        return err.response;
      });
  },
  spildexTokenHandler(body, timeout) {
    let header = {
      Clientname: "spil",
      Username: "41f23c9bb834192caf7157fe14f22e4192a011f6",
      Password: "b93066489eb9fb4bd7944d81416bc1c14a923167",
    };

    return axios
      .post(
        `${config.spildexApiUrl}/access_token`,
        JSON.stringify(body.params),
        {
          timeout: timeout,
          headers: header,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        if (!err.response || err.code === "ECONNABORTED") {
          return {
            status: 400,
            data: { msg: "Request timeout. Please check your network and try again later." },
          };
        }
        return err.response;
      });
  },

  // NONAKTIF — panggilan FAST sekarang lewat tms_reapi (reApiRequest → fordex/loading-list/*, fordex/*).
  // Sengaja di-comment (bukan dihapus) untuk referensi/rollback. Kredensial FAST TIDAK boleh ditaruh di frontend.
  // fordexHandler(token, body, endpoint, timeout = 0) {
  //   let header = {
  //     Client_name: config.isProd ? "fdx_forsis" : "jafar",
  //     Authorization: "Bearer " + token,
  //     "Content-Type": "application/json",
  //   };
  //
  //   return axios
  //     .post(`${config.fordexApiUrl}/${endpoint}`, JSON.stringify(body.params), {
  //       timeout: timeout,
  //       headers: header,
  //     })
  //     .then((res) => {
  //       return res;
  //     })
  //     .catch((err) => {
  //       if (err.code == "ECONNABORTED" || !err.response) {
  //         return {
  //           status: 400,
  //           data: {
  //             msg: err.code == "ECONNABORTED"
  //               ? "Request timeout. Please check your network and try again later."
  //               : "Network error. Please check your connection.",
  //           },
  //         };
  //       }
  //       return err.response;
  //     });
  // },

  // fordexTokenHandler(body, timeout = 0) {
  //   let header;
  //
  //   if (config.isProd) {
  //     header = {
  //       client_name: "fdx_forsis",
  //       username: "<FORDEX_USERNAME>", // dihapus dari repo — ambil dari secret store
  //       password: "<FORDEX_PASSWORD>", // dihapus dari repo — ambil dari secret store
  //       "Content-Type": "application/json",
  //     };
  //   } else {
  //     header = {
  //       client_name: "jafar",
  //       username: "<FORDEX_DEV_USERNAME>", // dihapus dari repo
  //       password: "<FORDEX_DEV_PASSWORD>", // dihapus dari repo
  //       "Content-Type": "application/json",
  //     };
  //   }
  //
  //   return axios
  //     .post(`${config.fordexApiUrl}/accesstoken`, JSON.stringify(body.params), {
  //       timeout: timeout,
  //       headers: header,
  //     })
  //     .then((res) => {
  //       return res;
  //     })
  //     .catch((err) => {
  //       if (err.code == "ECONNABORTED" || !err.response) {
  //         return {
  //           status: 400,
  //           data: {
  //             msg: err.code == "ECONNABORTED"
  //               ? "Request timeout. Please check your network and try again later."
  //               : "Network error. Please check your connection.",
  //           },
  //         };
  //       }
  //       return err.response;
  //     });
  // },
};

export default mainAPI;
